// extracted by mini-css-extract-plugin
export default {"container":"ServiciosSociales_container__Ny9pK","title":"ServiciosSociales_title__8SkPB","grid":"ServiciosSociales_grid__4KtW7"};